// extracted by mini-css-extract-plugin
export default {"author":"_d93ca173","authorName":"_b4631754","authorLogo":"_19a34958","expertLogo":"_3a180c03","authorInfo":"_4f9574bd"};